import { LocationNumbersService } from '../../../services'

const deletePool = async function ({ dispatch, state }, config) {
  const { locationId, payload } = config
  try {
    const data = await LocationNumbersService.deletePool(locationId, payload)
    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchNumberPool', {
      numberPools: state.numberPoolIDs,
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: '',
      },
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default deletePool
